import React from "react";
import { listaMasajes } from "../../assets/data/masajes";

const FormularioCliente = ({
  nombre, setNombre,
  primerApellido, setPrimerApellido,
  segundoApellido, setSegundoApellido,
  telefono, handleTelefonoChange,
  telefonoValido,
  tipoMasaje, setTipoMasaje,
  comentarioCliente, setComentarioCliente
}) => {
  return (
    <div style={{ marginTop: "20px", maxWidth: "300px" }}>
      <input
        type="text"
        placeholder="Nombre*"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />
      <input
        type="text"
        placeholder="Primer apellido*"
        value={primerApellido}
        onChange={(e) => setPrimerApellido(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />
      <input
        type="text"
        placeholder="Segundo apellido"
        value={segundoApellido}
        onChange={(e) => setSegundoApellido(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />
      <input
        type="tel"
        placeholder="Teléfono móvil*"
        value={telefono}
        onChange={handleTelefonoChange}
        style={{
          width: "100%",
          marginBottom: "10px",
          padding: "8px",
          border: !telefonoValido ? "1px solid red" : "1px solid #8f8f9d",
        }}
      />
      {!telefonoValido && (
        <p style={{ color: "red", fontSize: "12px" }}>Número de teléfono inválido.</p>
      )}

      <select
        value={tipoMasaje}
        onChange={(e) => setTipoMasaje(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      >
        <option value="">Selecciona tipo de masaje*</option>
        {listaMasajes.map((masaje, index) => (
          <option key={index} value={masaje.altTitle}>
            {masaje.altTitle} - {masaje.precio} €
          </option>
        ))}
      </select>

      <textarea
        placeholder="Comentario (opcional)"
        value={comentarioCliente}
        onChange={(e) => setComentarioCliente(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px", minHeight: "60px", resize: "vertical" }}
      />
    </div>
  );
};

export default FormularioCliente;